import { useState, useRef } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import { End, Form, Loader, Start } from 'components/Questionnaire';
import { useQuestionnaire } from 'hooks/useQuestionnaire';
import { openSnackbar } from 'store/application';
import DefaultWrapper from 'shared-components/DefaultWrapper';
import { TaskStatus } from 'utils/enum';

const Questionnaire = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [completed, setCompleted] = useState(false);

  const participantTaskId = parseInt(useParams()?.id);
  const {
    form,
    defaultValues,
    readOnly,
    isLoading,
    participantTask,
    participantTaskTitle,
    startScreenData,
    celebrationScreenData,
    page,
    taskStatus,
    isSubmitting,
    handleSubmit,
    handleSave,
    handleNext,
    handleTaskEntryChange,
  } = useQuestionnaire({
    participantTaskId,
    onSubmit : () => {
      setCompleted(true);
      dispatch(
        openSnackbar({
          type    : 'success',
          message : 'Questionnaire answers submitted',
        })
      );
    },
    onError : () =>
      dispatch(
        openSnackbar({
          type : 'error',
          message :
            'Could not save your questionnaire answers. Please try again',
        })
      ),
  });
  const formRef = useRef();
  if (form && !formRef.current) {
    formRef.current = form;
  }
  const [started, setStarted] = useState(!startScreenData);

  const handleStart = () => {
    setStarted(true);
  };

  const handleExit = () => navigate('/homepage');
 
  const crumbs = [
    { title: 'My Tasks', isActive: false, linkTo: '/my-tasks' },
    { title: participantTaskTitle, isActive: true },
  ];

  if ((isLoading && !formRef.current) || isSubmitting) return <Loader />;

  const content = completed
    ? (
      <End
        onEnd={handleExit} data={celebrationScreenData}
      />
    )
    : started ||
    [TaskStatus.Completed, TaskStatus.Inprogress].includes(taskStatus)
      ? (
        <Form
          form={form}
          page={page}
          onSubmit={handleSubmit}
          onSave={handleSave}
          onNext={handleNext}
          handleTaskEntryChange={handleTaskEntryChange}
          onCancel={handleExit}
          defaultValues={defaultValues}
          readOnly={readOnly}
        />
      )
      : (
        <Start
          onStart={handleStart} data={startScreenData}
        />
      );

  return (
    <DefaultWrapper
      crumbs={crumbs}
      showHeader={true}
      margin='20px 0 0px 0'
      sx={{ maxWidth: '100%' }}>
      {content}
    </DefaultWrapper>
  );
};

export default Questionnaire;
